import { useState } from 'react';

import { useImportQuizToWorkspaceBySpreadsheetMutation } from '~teacher/hook/workspaces/useImportQuizToWorkspaceBySpreadsheetMutation';

interface UseImportQuizByExcelToWorkspaceParams {
  workspaceId: string;
  parentId: string;
}

export function useImportQuizBySpreadsheetToWorkspace({
  workspaceId,
  parentId,
}: UseImportQuizByExcelToWorkspaceParams) {
  const [isUploadDisabled, setIsUploadDisabled] = useState(false);

  const mutation = useImportQuizToWorkspaceBySpreadsheetMutation();

  const handleUploadExcelFile = (file: File) => {
    setIsUploadDisabled(true);
    mutation.mutate(
      { file, workspaceId, parentId },
      {
        onSettled: () => {
          setIsUploadDisabled(false);
        },
      }
    );
  };

  return {
    ...mutation,
    isUploadDisabled,
    handleUploadExcelFile,
  };
}
